import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import type { Task } from './_types';

export function normalizeTask(task: any): Task {
  const normalized = camelcaseKeys(task, { deep: true });
  normalized.defaultPayrate = centsToDollars(normalized.defaultPayrate);
  return normalized;
}

export function denormalizeTask(task: Partial<Task>): any {
  if (task.defaultPayrate) {
    task.defaultPayrate = dollarsToCents(task.defaultPayrate);
  }
  return decamelizeKeys(task, { deep: true });
}

function centsToDollars(cents: number): number {
  return cents / 100.0;
}

function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100);
}
